import VoyageTweaksData from "../data";

export default function voyageTweaksDataFromJson(json) {
    return new VoyageTweaksData(
        json.id,
        json.mesh_spacing_distance,
        json.mesh_speed_distance,
        json.mesh_width,
        json.optimisation_mode,
        json.solutions_limit,
        json.reduce_mesh_to_base_route,
    );
}